<ng-container *ngIf="{ unread: unreadCount$ | async, totalNotifications: totalNotifications$ | async } as counts">
  <div class="notifications-menu mb-4">
    <!-- Desktop view -->
    <div class="d-none d-lg-flex gap-3 align-items-center justify-content-end">
      <form class="context-form">
        <formly-form [fields]="contextFields" [form]="contextForm" [model]="contextModel"></formly-form>
      </form>

      <astrobin-toggle-button
        [label]="'Only unread' | translate"
        [value]="onlyUnread"
        (toggle)="toggleShowRead($event)"
      ></astrobin-toggle-button>

      <button
        [class.loading]="loadingService.loading$ | async"
        [disabled]="!!contextModel.message || !!contextModel.context || (unreadCount$ | async) === 0"
        (click)="markAllAsRead()"
        id="mark-all-as-read"
        class="btn btn-primary"
      >
        {{ "Mark all as read" | translate }}
      </button>

      <a class="btn btn-link link-secondary" routerLink="/notifications/settings">
        <fa-icon icon="cog"></fa-icon>
        <span class="sr-only">{{ "Settings" | translate }}</span>
      </a>

      <astrobin-refresh-button [loading]="refreshing" (click)="refreshNotifications()"></astrobin-refresh-button>
    </div>

    <!-- Mobile view - Top controls -->
    <div class="d-flex d-lg-none align-items-center justify-content-between mb-3">
      <!-- Kebab menu for options -->
      <div ngbDropdown>
        <fa-icon class="dropdown-toggle no-toggle p-3 ms-2" icon="ellipsis-v" ngbDropdownToggle></fa-icon>

        <div ngbDropdownMenu>
          <astrobin-toggle-button
            [label]="'Only unread' | translate"
            [value]="onlyUnread"
            (toggle)="toggleShowRead($event)"
            ngbDropdownItem
          ></astrobin-toggle-button>

          <button ngbDropdownItem routerLink="/notifications/settings">
            {{ "Settings" | translate }}
          </button>

          <button (click)="refreshNotifications()" ngbDropdownItem>
            {{ "Refresh" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="notifications !== null; else loading">
    <ng-container *ngIf="notifications.length > 0; else noNotifications">
      <!-- Mark all as read button at the top -->
      <button
        [class.loading]="loadingService.loading$ | async"
        [disabled]="!!contextModel.message || !!contextModel.context || (unreadCount$ | async) === 0"
        (click)="markAllAsRead()"
        id="mark-all-as-read-mobile"
        class="btn btn-primary d-lg-none mb-3"
      >
        {{ "Mark all as read" | translate }}
      </button>

      <ngb-pagination [collectionSize]="counts.totalNotifications" (pageChange)="pageChange($event)" [(page)]="page">
        <ng-template ngbPaginationPrevious>&larr;</ng-template>
        <ng-template ngbPaginationNext>&rarr;</ng-template>
      </ngb-pagination>

      <table class="table table-striped notifications">
        <tbody>
          <tr *ngFor="let notification of notifications" id="notification-{{ notification.id }}" class="notification">
            <td
              [class.read]="notification.read"
              [class.unread]="!notification.read"
              class="read-indicator d-table-cell"
            >
              <fa-icon (click)="toggleRead(notification)" class="read-icon" icon="eye"></fa-icon>
            </td>

            <td class="notification-context">
              <fa-icon [icon]="notification | notificationContextIcon" class="context-icon"></fa-icon>
            </td>

            <td class="message">
              <div
                [innerHTML]="notification.message | normalizeNotificationLink"
                (click)="notificationClicked(notification)"
              ></div>
              <div class="d-lg-none">
                <ng-container *ngTemplateOutlet="createdTemplate; context: { $implicit: notification }"></ng-container>
              </div>
            </td>

            <td class="created text-end d-none d-lg-table-cell">
              <ng-container *ngTemplateOutlet="createdTemplate; context: { $implicit: notification }"></ng-container>
            </td>
          </tr>
        </tbody>
      </table>

      <ngb-pagination [collectionSize]="counts.totalNotifications" (pageChange)="pageChange($event)" [(page)]="page">
        <ng-template ngbPaginationPrevious>&larr;</ng-template>
        <ng-template ngbPaginationNext>&rarr;</ng-template>
      </ngb-pagination>
    </ng-container>
  </ng-container>

  <ng-template #createdTemplate let-notification>
    <abbr [attr.title]="notification.created | localDate" class="no-wrap">
      {{ notification.created | localDate | timeago }}
    </abbr>
  </ng-template>

  <ng-template #noNotifications>
    <astrobin-empty-list></astrobin-empty-list>
  </ng-template>

  <ng-template #loading>
    <div *ngIf="loadingService.loading$ | async" class="app-loading active"></div>
  </ng-template>
</ng-container>
